import React from 'react';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardContent from '@material-ui/core/CardContent';
import { red } from '@material-ui/core/colors';
import withStyles from "@material-ui/core/styles/withStyles";
import * as PropTypes from "prop-types";
import {AddCircleOutlineTwoTone, Delete} from "@material-ui/icons";
import Modal from "@material-ui/core/Modal";
import RevisionModal from "./RevisionModal";
import moment from "moment";
import {BlueButton} from "../common/ButtonsConstants";
import { t } from '../../i18n';

const classes = () => ({
    card: {
        width: '100%',
    },
    avatar: {
        backgroundColor: red[500],
        fontSize: 10,
    },
});

class DocumentControlHeader extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            show: false,
            revision: this.props.revision,
        };
        this.showModal = this.showModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
    }

    showModal() {
        this.setState({
            show: true
        });
    }

    closeModal(updatedRevision) {
        if (updatedRevision) {
            this.setState({
                show: false,
                revision: updatedRevision,
            });
        } else {
            this.setState({
                show: false,
            });
        }
    }

    render() {
        const { classes, support } = this.props;
        const { show, revision } = this.state;

        const isRevision = revision.author && revision.approvedBy;

        return <div>
            <Card className={classes.card}>
                <CardHeader
                    action={
                        <BlueButton
                            variant="contained"
                            color="secondary"
                            startIcon={<AddCircleOutlineTwoTone/>}
                            onClick={this.showModal}
                            size="small"
                            style={{marginRight: '10px'}}
                            disabled={this.props.isReadOnly}
                        >
                            { t('common.add') }
                        </BlueButton>
                    }
                    title={
                        <span style={{color: "black"}}>
                            <p>{this.props.title}</p>
                        </span>
                    }
                    subheader={
                        <span style={{color: "darkblue"}}>
                            <p>{isRevision && `${t('context.common.revision')} ${revision.number} ${t('context.common.author')}: ${revision.author}`}</p>
                            <p>{ t('context.common.approvedFor') }: {revision.approvedBy} {t('context.common.on')} {moment(revision.date).format('DD/MM/YYYY')}</p>
                        </span>
                    }
                />
                <CardContent>
                    <hr/>
                    {this.props.children}
                </CardContent>
            </Card>
            <Modal
                aria-labelledby="simple-modal-title"
                aria-describedby="simple-modal-description"
                open={show}
                onClose={() => this.closeModal(null)}
            >
                <RevisionModal revision={revision} postSubmit={this.closeModal} support={support}/>
            </Modal>
        </div>
    }
}

DocumentControlHeader.propTypes = {
    revision: PropTypes.object.isRequired,
    support: PropTypes.object.isRequired,
    title: PropTypes.string.isRequired,
    isReadOnly: PropTypes.bool
};

export default withStyles(classes)(DocumentControlHeader);